import { useCallback } from 'react';

import { IFilterDefinition, OptionType } from '@evinced-private/ui-common';

import { getMfaSingleSessionFilterDefinitions } from 'src/apps/mfa/pages/single-session/filters-section/MfaSingleSessionFilterDefinitions';
import { TMfaSessionIssuesFilterOptions } from 'src/apps/mfa/services/MfaDashboardServiceTypes';
import { useMobileScanFilters } from 'src/apps/mobile-common/hooks/useMobileScanFilters';

interface UseMfaSingleSessionFiltersParams {
	allLabels: OptionType[];
	selectedLabels: OptionType[];
	filterOptions: TMfaSessionIssuesFilterOptions;
}

interface UseMfaSingleSessionFiltersReturn {
	filterDefinitions: IFilterDefinition[];
	mergedFilterOptions: TMfaSessionIssuesFilterOptions;
}

export const useMfaSingleSessionFilters = ({
	allLabels,
	selectedLabels,
	filterOptions
}: UseMfaSingleSessionFiltersParams): UseMfaSingleSessionFiltersReturn => {
	const getFilterDefinitions = useCallback(
		(
			scansLoadOptions: (searchText: string, callback: (options: OptionType[]) => void) => void,
			scansOptions: OptionType[]
		) => getMfaSingleSessionFilterDefinitions(scansLoadOptions, scansOptions),
		[]
	);

	return useMobileScanFilters({
		allScans: allLabels,
		selectedScans: selectedLabels,
		filterOptions,
		getFilterDefinitions
	});
};
